import * as React from 'react';
import styled from '@emotion/styled-base';
import Box from './Box';
import { hidden } from '../../utils/layout';
import { mediaRangeQueries } from '../../theme';

// const sizes: any = sizeAliases.reduce((prev, alias, index) => {
// 	prev[alias] = breakpoints[index]
// 	return prev
// }, {})

// const hidden = (size: string) => (props: any): any => {
// 	return props[size] ? {
// 		[mediaRangeQueries[size]]: {
// 			display: 'none'
// 		}
// 	 } : null
// }

const StyledHide = styled(Box)`
    ${Object.keys(mediaRangeQueries).map((key) => hidden(key))}
`;

interface HideProps {
    xs?: boolean
    sm?: boolean
    md?: boolean
    lg?: boolean
    xl?: boolean
    xxl?: boolean
    mobile?: boolean
    tablet?: boolean
    desktop?: boolean
    print?: boolean
}

const Hide: React.FC<HideProps> = StyledHide;

export { HideProps };

export default Hide;
